// @flow
import { PrioridadesActionTypes } from './constants';

type PrioridadesAction = { type: string, payload: {} | string };

// common success
export const prioridadesApiResponseSuccess = (actionType: string, data: any): PrioridadesAction => ({
    type: PrioridadesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const prioridadesApiResponseError = (actionType: string, error: string): PrioridadesAction => ({
    type: PrioridadesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// export const getPrioridad = (id: string): PrioridadesAction => ({
//     type: PrioridadesActionTypes.GET_PRIORIDAD,
//     payload: { id },
// });

// export const addPrioridad = (prioridad:any):PrioridadesAction=>({
//     type:PrioridadesActionTypes.ADD_PRIORIDAD,
//     payload:prioridad
// })
// export const updatePrioridad = (prioridad:any):PrioridadesAction=>({
//     type:PrioridadesActionTypes.UPDATE_PRIORIDAD,
//     payload:prioridad
// })
// export const deletePrioridad = (id:string):PrioridadesAction=>({
//     type:PrioridadesActionTypes.DELETE_PRIORIDAD,
//     payload:{id}
// })

export const listPrioridades = (): PrioridadesAction => ({
    type: PrioridadesActionTypes.LIST_PRIORIDADES,
    payload: {},
});


export const resetPrioridades = (): PrioridadesAction => ({
    type: PrioridadesActionTypes.RESET,
    payload: {},
});

